<template>
  <div
    :class="{'flex': displayHtmlCode || displayHtmlContent}"
    @paste="onPasteData"
    @keydown.capture="onKeydownCapture"
    @beforeinput="onBeforeInput"
  >
    <quill-editor
      :class="{'w-50-perc': displayHtmlCode || displayHtmlContent}"
      :ref="`${instance}-contentTextarea`"
      v-if="displayContentEditor"
      v-model="body"
      :options="editorOption"
      @change="onEditorChange"
      @ready="onEditorReady"
    >
      <div :id="'toolbar-' + instance" slot="toolbar">
        <span class="ql-formats">
          <button :id="`toolbar-ql-bold-${instance}`" class="ql-bold" :tabindex="-1">Bold</button>
          <b-tooltip :target="`toolbar-ql-bold-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Bold')}}</b-tooltip>
          <button :id="`toolbar-ql-italic-${instance}`" class="ql-italic" :tabindex="-1">Italic</button>
          <b-tooltip :target="`toolbar-ql-italic-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Italic')}}</b-tooltip>
          <button :id="`toolbar-ql-underline-${instance}`" class="ql-underline" :tabindex="-1">Underline</button>
          <b-tooltip :target="`toolbar-ql-underline-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Underline')}}</b-tooltip>
          <button :id="`toolbar-ql-strike-${instance}`" class="ql-strike" :tabindex="-1">Strike</button>
          <b-tooltip :target="`toolbar-ql-strike-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Strike')}}</b-tooltip>
        </span>

        <span class="ql-formats">
          <button :id="`toolbar-ql-blockquote-${instance}`" class="ql-blockquote" :tabindex="-1">Blockquote</button>
          <b-tooltip :target="`toolbar-ql-blockquote-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Blockquote')}}</b-tooltip>
          <!-- <button class="ql-header" value="1"></button>
          <button class="ql-header" value="2"></button> -->
        </span>

        <span class="ql-formats">
          <button :id="`toolbar-ql-list-odered-${instance}`" class="ql-list" value="ordered" :tabindex="-1"></button>
          <b-tooltip :target="`toolbar-ql-list-odered-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_List_Odered')}}</b-tooltip>
          <button :id="`toolbar-ql-list-bullet-${instance}`" class="ql-list" value="bullet" :tabindex="-1"></button>
          <b-tooltip :target="`toolbar-ql-list-bullet-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_List_Bullet')}}</b-tooltip>
        </span>

        <span class="ql-formats">
          <button :id="`toolbar-ql-script-sub-${instance}`" class="ql-script" value="sub" :tabindex="-1"></button>
          <b-tooltip :target="`toolbar-ql-script-sub-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Script_Sub')}}</b-tooltip>
          <button :id="`toolbar-ql-script-super-${instance}`" class="ql-script" value="super" :tabindex="-1"></button>
          <b-tooltip :target="`toolbar-ql-script-super-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Script_Super')}}</b-tooltip>
        </span>

        <span class="ql-formats">
          <button :id="`toolbar-ql-indent-down-${instance}`" class="ql-indent" value="-1" :tabindex="-1"></button>
          <b-tooltip :target="`toolbar-ql-indent-down-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Ident_Down')}}</b-tooltip>
          <button :id="`toolbar-ql-indent-up-${instance}`" class="ql-indent" value="+1" :tabindex="-1"></button>
          <b-tooltip :target="`toolbar-ql-indent-up-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Ident_Up')}}</b-tooltip>
        </span>

        <span class="ql-formats">
          <button :id="`toolbar-ql-direction-${instance}`" class="ql-direction" value="rtl" :tabindex="-1"></button>
          <b-tooltip :target="`toolbar-ql-direction-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Direction')}}</b-tooltip>
        </span>

        <!-- <span class="ql-formats">
          <b-tooltip :target="`toolbar-ql-color-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Font_Color')}}</b-tooltip>
          <b-tooltip :target="`toolbar-ql-background-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Font_Background')}}</b-tooltip>
          <select :id="`toolbar-ql-color-${instance}`" class="ql-color" :tabindex="-1">
            <option selected="selected"></option>
            <option value="#e60000"></option>
            <option value="#ff9900"></option>
            <option value="#ffff00"></option>
            <option value="#008a00"></option>
            <option value="#0066cc"></option>
            <option value="#9933ff"></option>
            <option value="#ffffff"></option>
            <option value="#facccc"></option>
            <option value="#ffebcc"></option>
            <option value="#ffffcc"></option>
            <option value="#cce8cc"></option>
            <option value="#cce0f5"></option>
            <option value="#ebd6ff"></option>
            <option value="#bbbbbb"></option>
            <option value="#f06666"></option>
            <option value="#ffc266"></option>
            <option value="#ffff66"></option>
            <option value="#66b966"></option>
            <option value="#66a3e0"></option>
            <option value="#c285ff"></option>
            <option value="#888888"></option>
            <option value="#a10000"></option>
            <option value="#b26b00"></option>
            <option value="#b2b200"></option>
            <option value="#006100"></option>
            <option value="#0047b2"></option>
            <option value="#6b24b2"></option>
            <option value="#444444"></option>
            <option value="#5c0000"></option>
            <option value="#663d00"></option>
            <option value="#666600"></option>
            <option value="#003700"></option>
            <option value="#002966"></option>
            <option value="#3d1466"></option>
          </select>

          <select :id="`toolbar-ql-background-${instance}`" class="ql-background" :tabindex="-1">
            <option value="#000000"></option>
            <option value="#e60000"></option>
            <option value="#ff9900"></option>
            <option value="#ffff00"></option>
            <option value="#008a00"></option>
            <option value="#0066cc"></option>
            <option value="#9933ff"></option>
            <option selected="selected"></option>
            <option value="#facccc"></option>
            <option value="#ffebcc"></option>
            <option value="#ffffcc"></option>
            <option value="#cce8cc"></option>
            <option value="#cce0f5"></option>
            <option value="#ebd6ff"></option>
            <option value="#bbbbbb"></option>
            <option value="#f06666"></option>
            <option value="#ffc266"></option>
            <option value="#ffff66"></option>
            <option value="#66b966"></option>
            <option value="#66a3e0"></option>
            <option value="#c285ff"></option>
            <option value="#888888"></option>
            <option value="#a10000"></option>
            <option value="#b26b00"></option>
            <option value="#b2b200"></option>
            <option value="#006100"></option>
            <option value="#0047b2"></option>
            <option value="#6b24b2"></option>
            <option value="#444444"></option>
            <option value="#5c0000"></option>
            <option value="#663d00"></option>
            <option value="#666600"></option>
            <option value="#003700"></option>
            <option value="#002966"></option>
            <option value="#3d1466"></option>
          </select>
        </span> -->

        <span class="ql-formats">
          <b-tooltip :target="`toolbar-ql-size-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Size')}}</b-tooltip>
          <select :id="`toolbar-ql-size-${instance}`" class="ql-size" :tabindex="-1">
            <option value="small" />
            <!-- Note a missing, thus falsy value, is used to reset to default -->
            <option selected />
            <option value="large" />
            <option value="huge" />
          </select>
        </span>

        <span class="ql-formats">
          <b-tooltip :target="`toolbar-ql-align-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Align')}}</b-tooltip>
          <select :id="`toolbar-ql-align-${instance}`" class="ql-align" :tabindex="-1">
            <option selected="selected"></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
          </select>
        </span>

        <span class="ql-formats">
          <!-- <button :id="`toolbar-ql-link-${instance}`" class="ql-link" :tabindex="-1"></button>
          <b-tooltip :target="`toolbar-ql-link-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Link')}}</b-tooltip> -->
          <!-- <button class="ql-image"></button>
          <button class="ql-video"></button> -->
        </span>

        <span class="ql-formats">
          <b-tooltip :target="`toolbar-popover-userheader-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_UserHeader')}}</b-tooltip>
          <b-tooltip :target="`toolbar-popover-signatures-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Signature')}}</b-tooltip>
          <b-tooltip :target="`toolbar-popover-footer-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Footer')}}</b-tooltip>
          <b-button
            :tabindex="-1"
            class="btn-icon btn-sm"
            :id="`toolbar-popover-signatures-${instance}`"
            :ref="`toolbar-popover-signatures-${instance}`"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
            v-if="signatureDisplay"
          >
            <feather-icon icon="PenToolIcon" />
          </b-button>

          <b-popover
            :ref="`toolbar-popover-signatures-${instance}`"
            :target="`toolbar-popover-signatures-${instance}`"
            triggers="hover"
            placement="bottom"
          >
            <div>
              <b-button
                class=""
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                v-for="(item, index) in signatures"
                :key="index"
                @click="onSelectSignatureItem(item)"
              >
                {{ item }}
              </b-button>
            </div>
          </b-popover>

          <b-button
            :tabindex="-1"
            class="btn-icon btn-sm"
            :id="`toolbar-popover-userheader-${instance}`"
            :ref="`toolbar-popover-userheader-${instance}`"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
            v-if="userHeaderDisplay"
          >
            <feather-icon icon="TypeIcon" />
          </b-button>
          <b-popover
            :ref="`toolbar-popover-userheader-${instance}`"
            :target="`toolbar-popover-userheader-${instance}`"
            triggers="hover"
            placement="bottom"
          >
            <!-- v-if="form.userHeader.display" -->
            <div>
              <b-button
                class=""
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                v-for="(item, index) in userHeaders"
                :key="index"
                @click="onSelectUserHeaderItem(item)"
              >
                {{ item.name }}
              </b-button>
            </div>
          </b-popover>

          <b-button
            :tabindex="-1"
            class="btn-icon btn-sm"
            :id="`toolbar-popover-footer-${instance}`"
            :ref="`toolbar-popover-footer-${instance}`"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
          >
            <feather-icon icon="MinusIcon" />
          </b-button>
          <b-popover
            :ref="`toolbar-popover-footer-${instance}`"
            :target="`toolbar-popover-footer-${instance}`"
            triggers="hover"
            placement="bottom"
          >
            <div>
              <b-button
                class=""
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                v-for="(item, index) in [contentFooter]"
                :key="index"
                @click="onSelectFooterItem(item)"
              >
                {{ item }}
              </b-button>
            </div>
          </b-popover>

          <b-tooltip :target="`toolbar-acronyms-modal-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Acronyms')}}</b-tooltip>
          <b-button
            :id="`toolbar-acronyms-modal-${instance}`"
            :tabindex="-1"
            class="btn-icon btn-sm"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
            @click="openAcronymModal"
          >
            <feather-icon icon="HashIcon" />
          </b-button>
        </span>
        <span class="ql-formats">
          <b-tooltip :target="`toolbar-maximize-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Maximize')}}</b-tooltip>
          <b-tooltip :target="`toolbar-minimize-${instance}`" triggers="hover" no-fade>{{$t('SEND_NEWS.Toolbar_Minimize')}}</b-tooltip>
          <b-button
            :id="`toolbar-maximize-${instance}`"
            :tabindex="-1"
            v-if="!isMaximize"
            class="btn-icon btn-sm"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
            @click="onMaximize"
          >
            <feather-icon icon="Maximize2Icon" />
          </b-button>
          <b-button
            :id="`toolbar-minimize-${instance}`"
            :tabindex="-1"
            v-if="isMaximize"
            class="btn-icon btn-sm"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
            @click="onMinimize"
          >
            <feather-icon icon="Minimize2Icon" />
          </b-button>
        </span>
        <!-- <span class="ql-formats" v-if="!isSendNews">
          <b-tooltip :target="`toolbar-display-html-code-${instance}`" triggers="hover" no-fade>Mostrar código HTML</b-tooltip>
          <b-button
            :id="`toolbar-display-html-code-${instance}`"
            :tabindex="-1"
            class="btn-icon btn-sm toolbar-btn-html-code"
            :class="{'toolbar-btn-selected': displayHtmlCode}"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
            @click="changeHtmlCode()"
          >
            <feather-icon icon="CodeIcon" />
          </b-button>

          <b-tooltip :target="`toolbar-display-html-content-${instance}`" triggers="hover" no-fade>Mostrar conteúdo em HTML</b-tooltip>
          <b-button
            :id="`toolbar-display-html-content-${instance}`"
            :tabindex="-1"
            class="btn-icon btn-sm toolbar-btn-html-code"
            :class="{'toolbar-btn-selected': displayHtmlContent}"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="flat-primary"
            @click="changeHtmlContent"
          >
            <feather-icon icon="CodeIcon" />
          </b-button>
        </span> -->
      </div>
    </quill-editor>
    <!-- <div class="html-code-content" v-if="displayHtmlCode">{{body}}</div>
    <div class="html-content" v-if="displayHtmlContent">
      <iframe :srcdoc="text" width="100%" height="100%" scrolling="no" frameborder="no" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import "quill/dist/quill.core.css";
/* eslint-disable */
import "quill/dist/quill.snow.css";
/* eslint-disable */
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

import { BPopover, BButton, BTooltip } from "bootstrap-vue";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import Ripple from "vue-ripple-directive";
import formatFieldHelper from '@/helpers/format-field-helper';

export default {
  directives: {
    Ripple,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    isSendNews: {
      type: Boolean
    },
    contentFooter: {
      type: String
    },
    instance: {
      type: String
    },
    isMaximize: {
      type: Boolean,
    },
    currentBody: {
      type: String,
    },
    userHeaderDisplay: {
      type: Boolean,
    },
    signatureDisplay: {
      type: Boolean,
    },
    userHeaders: {
      type: Array,
    },
    signatures: {
      type: Array,
    },
    displayContentEditor: {
      type: Boolean,
    },
  },
  data() {
    return {
      body: "",
      text: "",
      quillInstance: null,
      editorOption: {
        modules: {
          toolbar: "#toolbar-" + this.instance,
          // clipboard: {
          //   matchers: [
          //     ['B', customMatcherA],
          //     [Node.TEXT_NODE, customMatcherB]
          //   ]
          // }
        },
        placeholder: "Íntegra",
        readOnly: this.readOnly,
      },
      signature: "",
      userHeader: "",
      displayHtmlCode: false,
      displayHtmlContent: false
    };
  },
  created() {
    if (this.currentBody) {
      console.log('currentBody: ',this.currentBody)
      this.body = this.currentBody;
      // this.text = this.currentBody;
    }

    // if (this.$refs[`${this.instance}-contentTextarea`]) {
    //   this.$refs[`${this.instance}-contentTextarea`].clipboard.addMatcher(Node.TEXT_NODE, function(node, delta) {
    //     return new Delta().insert(node.data);
    //   });

    //   this.$refs[`${this.instance}-contentTextarea`].clipboard.addMatcher('B', function(node, delta) {
    //     return delta.compose(new Delta().retain(delta.length(), { bold: true }));
    //   });
    // }
  },
  mounted() {
    this.applyReadOnly();
  },
  watch: {
    readOnly() {
      this.applyReadOnly();
    },
  },
  computed: {
    hasContentFooter() {
      return this.contentFooter != '';
    },
  },
  methods: {
    onEditorReady(quill) {
      this.quillInstance = quill || this.quillInstance;
      this.applyReadOnly();
    },
    applyReadOnly() {
      const enable = !this.readOnly;

      // Preferred: use the instance passed by the ready event.
      if (this.quillInstance && typeof this.quillInstance.enable === 'function') {
        this.quillInstance.enable(enable);
        return;
      }

      // Fallback: try to grab the quill instance from the ref (may not be ready on first tick).
      const ref = this.$refs[`${this.instance}-contentTextarea`];
      const candidate = Array.isArray(ref) ? ref[0] : ref;
      if (candidate && candidate.quill && typeof candidate.quill.enable === 'function') {
        this.quillInstance = candidate.quill;
        this.quillInstance.enable(enable);
        return;
      }

      // Last resort: retry shortly (Quill init is async in some flows).
      setTimeout(() => {
        if (this.readOnly !== !enable) {
          this.applyReadOnly();
        }
      }, 30);
    },
    onKeydownCapture(e) {
      if (!this.readOnly) return;

      // Allow navigation + copy.
      const allowedKeys = new Set([
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Shift',
        'Control',
        'Alt',
        'Meta',
        'CapsLock',
        'Tab',
        'Escape',
        'Home',
        'End',
        'PageUp',
        'PageDown',
      ]);

      const isCopy = (e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'C');
      const isSelectAll = (e.ctrlKey || e.metaKey) && (e.key === 'a' || e.key === 'A');
      if (isCopy || isSelectAll || allowedKeys.has(e.key)) return;

      e.preventDefault();
      e.stopPropagation();
    },
    onBeforeInput(e) {
      if (!this.readOnly) return;
      e.preventDefault();
      e.stopPropagation();
    },
    onPasteData(e) {
      if (this.readOnly) return;
      var clipboardData, pastedData;

      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();

      // Get pasted data via clipboard API
      clipboardData = e.clipboardData || window.clipboardData;
      pastedData = clipboardData.getData('Text');
      // console.log('[paste data]', pastedData);


      if (this.$refs[`${this.instance}-contentTextarea`]) {
        const currentQuillEditor = this.$refs[`${this.instance}-contentTextarea`].quill;
        // console.log('[editor instance]', currentQuillEditor);
        let textIndex = currentQuillEditor.selection.savedRange.index;
        if (currentQuillEditor.selection.savedRange.length > 0) {
          currentQuillEditor.deleteText(textIndex, currentQuillEditor.selection.savedRange.length);
        } else {
          // const range = currentQuillEditor.selection.savedRange.index;
          // console.log('[pasteDate][range selection]', range);
          // currentQuillEditor.setSelection(0, range + pastedData.length)
        }
          setTimeout(() => {
            currentQuillEditor.insertText(textIndex, pastedData, '', true);
          }, 200);
      }
    },
    changeHtmlCode() {
      this.displayHtmlCode = !this.displayHtmlCode;
      this.displayHtmlContent = false;
    },
    changeHtmlContent() {
      this.displayHtmlCode = false;
      this.displayHtmlContent = !this.displayHtmlContent;
    },
    openAcronymModal() {
      this.$emit('openAcronymsModal');
    },
    replaceAcronym(valueSearch, text) {
      this.body = formatFieldHelper.replaceAll(this.body, `#${valueSearch}#`, text);
    },
    onEditorChange({ quill, html, text }) {
      this.text = text;

      if (text.lastIndexOf('#') > 0) {
        const acronym = formatFieldHelper.getStringBetween(text, '#', '#');
        if (acronym) {
          this.$emit('getAcronyms', acronym);
          // this.getAcronyms(acronym);
        }
      }
      // console.log('[quill]', quill);
      // console.log('[html]', html);
      // console.log('[text]', text);

      // Consumers (e.g. AI drawer) can react to edits.
      this.$emit('change', { html: this.body, text });
    },
    onMaximize() {
      this.$emit("maximize");
    },
    onMinimize() {
      this.$emit("minimize", this.body);
    },
    onSelectFooterItem(item) {
      if (this.readOnly) return;
      this.body += `<br>${item}`
    },
    onSelectUserHeaderItem(item) {
      if (this.readOnly) return;
      this.userHeader = item.name;
      this.insertHeader();
    },
    onSelectSignatureItem(item) {
      if (this.readOnly) return;
      this.signature = item;
      this.insertSignature();
    },
    testHeaderInContent(content) {
      // Sao Paulo, dd de mm de aaaa
      // Procura por pattern '.*, ', se achar entao substitui
      return this.userHeaders
        .map((item) =>
          convertDatetimeHelper.convertUserHeaderToFormatDate(item.name)
        )
        .find((header) =>
          new RegExp(header.replace(/, .*/, ", ")).test(content)
        );
    },
    insertHeader() {
      const userHeaderFormatted = convertDatetimeHelper.convertUserHeaderToFormatDate(this.userHeader);

      console.log('[insertHeader]', userHeaderFormatted)
      if (!this.body.includes(userHeaderFormatted)) {
        if (this.body) {
          const newsContent = this.body.split(" - ");
          const firstLine = newsContent.shift();
  
          if (this.testHeaderInContent(firstLine)) {
            this.body =
              `${userHeaderFormatted} - <br><br><br><br>` + newsContent.join(" - ");
          } else {
            this.body = `${userHeaderFormatted} - <br><br><br><br>${this.body}`;
          }
        } else {
          this.body = `${userHeaderFormatted} - <br><br><br><br>${this.body} `;
        }
      }
      setTimeout(() => {
        this.focusContent();
      }, 200);

    },
    updateUserHeader(item) {
      // console.log('[updateUserHeader]', item);
      if (item) {
        const userHeaderFormatted = convertDatetimeHelper.convertUserHeaderToFormatDate(item.name);
        if (!this.body.includes(userHeaderFormatted)) {
          const newsContent = this.body.split(" - ");
          const firstLine = newsContent.shift();
          if (firstLine) {
            this.body = formatFieldHelper.replaceAll(this.body, firstLine, userHeaderFormatted)
          }
  
          // if (this.testHeaderInContent(firstLine)) {
          //   // console.log('found user header in body');
          //   // console.log(firstLine);
          //   // console.log(userHeaderFormatted);
          //   this.body = formatFieldHelper.replaceAll(this.body, firstLine, userHeaderFormatted)
          // } else {
          //   console.log('replacing user_header to new');
          //   this.body = formatFieldHelper.replaceAll(this.body, firstLine, userHeaderFormatted)
          // }
        }
      }
    },
    insertSignature() {
      if (!this.body.includes(this.signature)) {
        if (this.body.includes(this.contentFooter)) {
          const index = this.body.indexOf(this.contentFooter);
          const beforeStr = this.body.substring(0, index);
          const afterStr = this.body.substring(index);
          this.body = `${beforeStr}<br>${this.signature}<br>${afterStr}`;
          return;
          //   console.log(this.body.split(this.contentFooter));
          //  this.body = `${this.body}\n${this.signature}`;
        }
        this.body = `${this.body}<br>${this.signature}<br>`;
      }
    },
    insertAcronyms(text) {
      let index = -1;
      if (this.body.includes(this.signature)) {
        index = this.body.indexOf(this.signature);
      } else if (this.body.includes(this.contentFooter)) {
        index = this.body.indexOf(this.contentFooter);
      }

      if (index >= 0) {
        const beforeStr = this.body.substring(0, index);
        const afterStr = this.body.substring(index);
        this.body = `${beforeStr}<br>${text}<br>${afterStr}`;
        return;
      }

      this.body = `${this.body}<br>${text}<br>`;
    },
    focusContent() {
      // this.$refs[`${this.instance}-contentTextarea`].focus();
    },
  },
  components: {
    BPopover,
    quillEditor,
    BButton,
    BTooltip
  },
};
</script>

<style>
</style>
